import { StateUtils } from '../utils/state-utils';
import { initNear } from './near';
import { MESSAGES } from '../constans/constans';
import English from '../lang/en-US.json';
import Spanish from '../lang/es-ES.json';
import French from '../lang/fr-FR.json';

const userLanguage = navigator.language;
let userLocal;
let setLanguage;
if (userLanguage === 'en-US') {
  setLanguage = English;
  userLocal = 'en-Us';
} else if (userLanguage.includes('es')) {
  setLanguage = Spanish;
  userLocal = 'es-ES';
} else if (userLanguage.includes('fr')) {
  setLanguage = French;
  userLocal = 'fr-FR';
} else {
  setLanguage = English;
  userLocal = 'en-US';
}
const initialState = {
  app: {
    theme: localStorage.getItem('theme') ? localStorage.getItem('theme') : 'light',
    profile: {},
    profileProject: {},
    nftTokens: [],
    allFa: [],
    errors: {},
    validated: false,
    filesGen: [],
    filesOther: [],
    onSubmitedCarbonForm: false,
    toDeleteList: [],
    reloadFilesFlag: '',
    locales: localStorage.getItem('locales') ? localStorage.getItem('locales') : userLocal,
    messages: localStorage.getItem('locales') ? MESSAGES[localStorage.getItem('locales')] : setLanguage,
  },
  near: {
    initialized: false,
  },
};

export const { appStore, AppProvider } = StateUtils(initialState, 'app');

export const onAppMount = () => async ({ dispatch }) => {
  document.documentElement.classList.add(`theme-${initialState.app.theme}`);
  dispatch(initNear());
};
